import React, { useEffect, useState } from 'react';
import Icon from '../Icon/Icon';
import type { JobListPaginationProps } from './JobListPagination.interfaces';
import styles from './JobListPagination.module.scss';

const JobListPagination = ({
  currentPage,
  prev,
  next,
  canGoNext,
  canGoPrev,
  maxPage,
  jumpToPage,
}: JobListPaginationProps) => {
  const [stringValue, setStringValue] = useState('');
  useEffect(() => {
    setStringValue(currentPage.toString());
  }, [currentPage]);
  const digits = maxPage.toString().length;
  const width = `calc(${Math.max(digits, 1)}em + 1.5rem)`;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setStringValue(event.target.value);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      if (stringValue === '') {
        setStringValue(currentPage.toString());
      } else {
        jumpToPage(parseInt(stringValue));
      }
    }
  };

  const handleBlur = () => {
    if (stringValue === '') {
      setStringValue(currentPage.toString());
    }
  };

  return (
    <div className={styles.base}>
      <button
        onClick={prev}
        disabled={!canGoPrev}
        aria-label="Zurück"
        className={styles.button}
      >
        <Icon
          className={styles.icon}
          variant={'action/chevron-left'}
          size="iconSize20"
        />
      </button>
      <div className={styles.middle}>
        <input
          type="number"
          value={stringValue}
          min={1}
          max={maxPage}
          style={{ width }}
          className={styles.input}
          aria-label="Seite"
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
        />
        <span>von {maxPage}</span>
      </div>
      <button
        onClick={next}
        disabled={!canGoNext}
        aria-label="Weiter"
        className={styles.button}
      >
        <Icon
          className={styles.icon}
          variant={'action/chevron-right'}
          size="iconSize20"
        />
      </button>
    </div>
  );
};

export default JobListPagination;
